import React from "react";
import type { PromptSuggestion } from "./types";

interface SuggestionsCardProps {
  suggestions: PromptSuggestion[];
  onSelect: (question: string) => void;
  disabled: boolean;
}

export const SuggestionsCard: React.FC<SuggestionsCardProps> = ({
  suggestions,
  onSelect,
  disabled,
}) => {
  return (
    <div className="-mx-[2px] w-[calc(100%_+_4px)] p-2 bg-slate-50 border border-gray-200 rounded-lg">
      <div className="flex gap-2 flex-wrap">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion.id}
            onClick={() => onSelect(suggestion.question)}
            disabled={disabled}
            className="rounded-md font-semibold inline-flex items-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-default-600 bg-white hover:bg-slate-50 text-default-800 border border-gray-200 shadow-sm text-gray-500 px-2.5 py-1.5 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span className="truncate">{suggestion.question}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
